export default __webpack_public_path__ + "static/media/img5.e1d0098f.png";